export default __webpack_public_path__ + "images/46680e145fceb3ac5530b679a722be5b-photography_small.webp";